import { ParametrosCooperativa, ParametrosCoop } from 'api/Assessor/parametros';

interface ParametrosPagination {
  size: number;
  page: number;
}

interface ParametrosState {
  list: Array<ParametrosCoop>;
  listIsLoading: boolean;
  items: Array<ParametrosCooperativa>;
  isLoading: boolean;
  pagination: ParametrosPagination;
  count: number;
  currentCoop: string;
}

type ParametrosActionType =
  | 'setItems'
  | 'loading'
  | 'loaded'
  | 'setPagination'
  | 'setCount'
  | 'setList'
  | 'loadingList'
  | 'listLoaded'
  | 'setCurrentCoop';

interface ParametrosAction {
  type: ParametrosActionType;
  value?: any;
}

export const parametrosInitialState: ParametrosState = {
  list: [],
  items: [],
  isLoading: false,
  pagination: {
    size: 10,
    page: 1,
  },
  currentCoop: '',
  count: 0,
  listIsLoading: false,
};

export const parametrosReducer = (
  state: ParametrosState,
  action: ParametrosAction
): ParametrosState => {
  switch (action.type) {
    case 'setItems':
      return { ...state, items: action.value };
    case 'loading':
      return { ...state, isLoading: true };
    case 'loaded':
      return { ...state, isLoading: false };
    case 'setPagination':
      return { ...state, pagination: action.value };
    case 'setCount':
      return { ...state, count: action.value };
    case 'setList':
      return { ...state, list: action.value };
    case 'loadingList':
      return { ...state, listIsLoading: true };
    case 'listLoaded':
      return { ...state, listIsLoading: false };
    case 'setCurrentCoop':
      return { ...state, currentCoop: action.value };
    default:
      return state;
  }
};
